/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import {IStore2} from 'tau/configuration'
import {getSubset} from '../utils'

export interface Process {
  id: number
  name: string
}

export class ProcessService {
  private processMap = new Map<string, string>()

  private store2: IStore2

  constructor({store2}) {
    this.store2 = store2
  }

  public async getProcessNames(processIds: string[]): Promise<Map<string, string>> {
    const idsToFetch = processIds.filter((id) => !this.processMap.has(id))

    const processes = await this.store2.findAll<Process>(
      `process?select={id,name}&where=(id in [${idsToFetch.join(',')}])`
    )

    processes.forEach((process) => {
      this.processMap.set(process.id.toString(), process.name)
    })

    return getSubset(this.processMap, processIds)
  }
}
